<LOSx-entity-documents-tab
  [entityType]="entityType"
  [entityId]="entityId"
  [entityDocuments]="entityDocuments"
  [callbackUpload]="uploadDocument"
  [callbackDelete]="deleteDocument"
>
</LOSx-entity-documents-tab>
